import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=b5905450&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports